import { z } from "zod";
// =============================================================================
// ACCESS GRANT (organization "public_catalog" root)
// =============================================================================
// Fields present on every representation of a grant, including the creation
// response — which does NOT include lifecycle metadata (status/createdAt/
// revokedAt), only what's shown in the contract's create example.
const AccessGrantCoreSchema = z.object({
    id: z.string(),
    purpose: z.string(),
    allowedOrigins: z.array(z.string()),
    captchaRequired: z.boolean(),
    expiresAt: z.string().nullable(),
});
// The contract's text implies list/GET responses add lifecycle/policy
// metadata (status/createdAt/revokedAt) on top of the core fields, but the
// live API returns the same core-only shape for list as for create — these
// three fields are not actually present. Kept optional (not required) so the
// UI can render once that's confirmed/fixed backend-side, without crashing
// meanwhile; do not assume they're populated.
export const AccessGrantSchema = AccessGrantCoreSchema.extend({
    status: z.enum(["active", "revoked"]).optional(),
    createdAt: z.string().optional(),
    revokedAt: z.string().nullable().optional(),
});
export const AccessGrantCreationSchema = AccessGrantCoreSchema.extend({
    token: z.string(),
});
export const CreateAccessGrantInputSchema = z.object({
    allowedOrigins: z.array(z.string()).min(1).max(20),
    captchaRequired: z.boolean().optional(),
});
